/**
 * Created by mqamhieh on 12/11/16.
 */
window.ProfilePhotoForm = function(scope, userId, source) {
    let self = this;
    let formName = "profile-photo-form";
    let _protected = BaseForm.call(self, formName, scope);
    self.userId = userId;
    self.source = source;

    // Dependent on profilePicUpload directive

    self.save = () => {
        var defer = $q.defer();

        defer.resolve();

        return defer.promise;
    }
};